import { Actions } from '../enums/ActionEnums';
import { ActionType, UserType } from '../models/appContext';

export const userReducer = (state: UserType, action: ActionType): UserType => {
  switch (action.type) {
    case Actions.SetUser:
      return {
        data: action.payload.data,
        token: action.payload.token
      };
    case Actions.RemoveUser:
      return { data: null, token: null };
    default:
      return state;
  }
};

export const selectedUserReducer = (state: IUser | null, action: ActionType): IUser | null => {
  switch (action.type) {
    case Actions.SetSelectedUser:
      return action.payload.user;
    case Actions.ResetSelectedUser:
      return null;
    default:
      return state;
  }
};
